import React from 'react';
import { motion } from 'framer-motion';
import { Flame, ShoppingCart, CalendarRange, Sparkles } from 'lucide-react';
export function Mechanism() {
  return <section className="py-14 md:py-16 bg-brand-navy text-white relative overflow-hidden" data-id="element-224">
      {/* Decorative background elements */}
      <div className="absolute top-0 right-0 -mt-20 -mr-20 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-225"></div>
      <div className="absolute bottom-0 left-0 -mb-20 -ml-20 w-80 h-80 bg-brand-green/10 rounded-full blur-3xl" data-id="element-226"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl relative z-10 text-center" data-id="element-227">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-228">
          {/* Icon */}
          <div className="inline-flex items-center justify-center p-3 bg-brand-gold/20 rounded-full mb-6" data-id="element-229">
            <Flame className="w-8 h-8 text-brand-gold" data-id="element-230" />
          </div>

          {/* Eyebrow */}
          <p className="text-brand-gold text-xs sm:text-sm font-bold uppercase tracking-[0.2em] mb-4" data-id="element-231">
            Presentamos
          </p>

          {/* Title */}
          <h2 className="text-4xl md:text-6xl font-serif font-bold mb-6 text-brand-cream leading-tight" data-id="element-232">
            El <span className="text-brand-gold" data-id="element-233">Método Fuego Cero</span>
          </h2>

          {/* Lead */}
          <p className="text-xl md:text-2xl text-brand-cream/90 font-medium mb-10 leading-relaxed max-w-2xl mx-auto" data-id="element-234">
            Un sistema diseñado específicamente para el metabolismo de la mujer
            chilena de +40.
          </p>

          {/* Body block */}
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 p-7 sm:p-10 rounded-2xl text-left space-y-5" data-id="element-235">
            <p className="text-xl sm:text-2xl font-serif text-brand-gold leading-snug" data-id="element-236">
              No es una dieta restrictiva.
            </p>

            <p className="text-base sm:text-lg text-brand-cream/85 leading-relaxed" data-id="element-237">
              Es un protocolo de{' '}
              <span className="font-semibold text-brand-cream" data-id="element-238">
                "extinción"
              </span>{' '}
              que utiliza ingredientes que ya conoces — los que encuentras en el{' '}
              <span className="font-semibold text-brand-cream" data-id="element-239">Líder</span>, el{' '}
              <span className="font-semibold text-brand-cream" data-id="element-240">Jumbo</span> o la{' '}
              <span className="font-semibold text-brand-cream" data-id="element-241">
                feria de tu barrio
              </span>{' '}
              — para{' '}
              <span className="font-semibold text-brand-gold" data-id="element-242">
                apagar la inflamación celular en 15 minutos o menos
              </span>
              , estabilizando tus hormonas sin estrés y sin complicaciones.
            </p>

            <div className="border-t border-white/10 pt-5" data-id="element-243">
              <p className="text-base sm:text-lg text-brand-cream/85 leading-relaxed mb-2" data-id="element-244">
                La diferencia no está en comer menos.{' '}
                <span className="text-brand-cream/60" data-id="element-245">
                  No está en sufrir más.
                </span>
              </p>
              <p className="text-lg sm:text-xl font-serif font-semibold text-brand-cream leading-snug" data-id="element-246">
                Está en saber exactamente{' '}
                <span className="text-brand-gold italic" data-id="element-247">
                  qué meter al carrito.
                </span>
              </p>
            </div>
          </div>

          {/* Three-pillar tagline */}
          <motion.div initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.3
        }} className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10" data-id="element-248">
            <div className="flex flex-col items-center gap-2 p-4" data-id="element-249">
              <ShoppingCart className="w-7 h-7 text-brand-gold" strokeWidth={1.75} data-id="element-250" />
              <p className="font-serif font-semibold text-brand-cream" data-id="element-251">
                Un carrito diferente.
              </p>
            </div>
            <div className="flex flex-col items-center gap-2 p-4" data-id="element-252">
              <CalendarRange className="w-7 h-7 text-brand-gold" strokeWidth={1.75} data-id="element-253" />
              <p className="font-serif font-semibold text-brand-cream" data-id="element-254">
                Una semana diferente.
              </p>
            </div>
            <div className="flex flex-col items-center gap-2 p-4" data-id="element-255">
              <Sparkles className="w-7 h-7 text-brand-gold" strokeWidth={1.75} data-id="element-256" />
              <p className="font-serif font-semibold text-brand-cream" data-id="element-257">
                Un abdomen diferente.
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}